import React from "react";

const About = () => {
  return (
    <div id="aboutMeSection">
      {/* TODO: dynamically display rich text */}
      <span className="font-bold md:text-xl"> {">"} ABOUT ME</span>
      <p className="font-thin text-sm md:text-lg my-2 md:my-5">
        I am a web developer specialising in
        <strong className="text-transparent font-bold bg-clip-text bg-gradient-to-r from-backgroundLight to-primary">
          {" "}
          frontend development.{" "}
        </strong>
        With my experience in the field, I can help you design, develop, test,
        and bring your project to life.
      </p>
      <p className="font-thin text-sm md:text-lg my-5">
        From the initial idea to the{" "}
        <strong className="text-transparent font-bold bg-clip-text bg-gradient-to-r from-backgroundLight to-primary">
          final product,
        </strong>{" "}
        I will guide you through the entire process or support you where you
        most need it.
      </p>
      <p className="font-thin text-sm md:text-lg my-5">
        Currently, I am working at
        <strong className="font-bold text-transparent bg-clip-text bg-gradient-to-r from-backgroundLight to-primary">
          {" "}
          Hexagon{" "}
        </strong>
        as a
        <strong className="text-transparent font-bold bg-clip-text bg-gradient-to-r from-backgroundLight to-primary">
          {" "}
          software engineer,
        </strong>{" "}
        in addition to supporting and maintaining various projects from my
        customers.
      </p>
    </div>
  );
};

export default About;
